import styled from 'styled-components';

export const StyledTable = styled.div`
  .row1,
  .row2 {
    display: flex;
  }
  .row1 {
    justify-content: space-between;
  }
  .row2 {
    padding-top: 10px;
  }
  .col1 div {
    display: inline-block;
    padding-right: 20px;
  }

  .col2 div {
    display: inline-block;
    padding-right: 20px;
  }

  .col2 {
    width: 30%;
    text-align: center;
    white-space: pre-wrap;
  }

  .col2_1 {
    width: 40%;

    white-space: pre-wrap;
  }
  .col2_1 div {
    display: block;
    padding-bottom: 5px;
  }

  .col2_2 div {
    display: block;
  }
  .col2_2 {
    width: 30%;
    padding: 0 10px;
  }
  .col2_3 div {
    display: block;
  }
  .col2_3 {
    width: 30%;
    text-align: center;
  }
  .tab_but {
    width: 209px;
    height: 30px;
  }
  .tab_but_revoke {
    margin-top: 5px;
    width: 209px;
    background: rgba(0, 0, 0, 0.05);
    color: black;
    padding: 3px 6px;
  }
  .tab_but_revoke:hover {
    margin-top: 5px;
    width: 209px;
    background: rgba(0, 0, 0, 0.09);
    color: rgba(255, 0, 0, 1);
    text-decoration: underline;
  }
`;
